module.exports = __webpack_public_path__ + "img/Oreo.b50a56d2.webp";